// extracted by mini-css-extract-plugin
export default {"become_fan_button":"become_fan_button__e74d395d"};